import moment from "moment";
import { PoolRefundPolicy } from "../../constants/pool";
import { UserInvestmentRefundSchema } from "../../constants/user-investment";

export const checkCanRefund = (option: {
  poolTgeDate?: Date;
  poolRefundPolicy?: PoolRefundPolicy;
  investmentRefundPayload?: UserInvestmentRefundSchema;
}) => {
  const { poolTgeDate, poolRefundPolicy, investmentRefundPayload } = option;

  const { refundable, explicitRefundWindowInSeconds } = poolRefundPolicy ?? {};
  const { status, requestedDate, refundedDate } = investmentRefundPayload ?? {};

  let canRefund = refundable;

  if (status || requestedDate || refundedDate) {
    canRefund = false;
    return canRefund;
  }

  const currentTime = moment();
  const tge = moment(poolTgeDate);
  const timeDiffInSeconds = currentTime.diff(tge, "seconds");


  if (poolTgeDate) {
    const refundWindowInSec = explicitRefundWindowInSeconds ?? 0;
    const windowClosed = refundWindowInSec - Math.abs(timeDiffInSeconds) <= 0;

    if (windowClosed) {
      canRefund = false;
      return canRefund;
    }
  }

  return canRefund;
};